module.exports = __webpack_public_path__ + "static/Yolanda-0760804478a342b8ec61d63b07b0f52f.png";